import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { useRemoveFromCart } from '../../../hooks/use-remove-from-cart.js';
import { RemoveButton } from '../components/RemoveButton.js';

const RemoveButtonContainer = ({ lineItem , onSuccess  })=>{
    const [removeFromCart, { loading  }] = useRemoveFromCart(lineItem, onSuccess);
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            removeFromCart: getLabel('cart.actions.removeFromCart')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(RemoveButton, {
        isLoading: loading,
        caption: labels.removeFromCart,
        onClick: removeFromCart
    });
};

export { RemoveButtonContainer };
//# sourceMappingURL=RemoveButtonContainer.js.map
